<div class="container">
  <ion-searchbar
    [placeholder]="'user.search' | translate"
    show-clear-button="focus"
    (ionInput)="handleSearchInput($event)"
  ></ion-searchbar>

  <div class="counts-row">
    <span class="count-item"
      ><ion-icon class="green" name="checkmark-circle-outline"></ion-icon>
      {{ activeCount }} {{ "user.active" | translate }}</span
    >
    @if (deactivatedCount > 0) {
    <span class="count-item"
      ><ion-icon class="orange" name="checkmark-circle-outline"></ion-icon>
      {{ deactivatedCount }} {{ "user.deactivated" | translate }}</span
    >
    } @if (deletedCount > 0) {
    <span class="count-item"
      ><ion-icon class="red" name="close-circle-outline"></ion-icon>
      {{ deletedCount }} {{ "user.deleted" | translate }}</span
    >
    }
  </div>

  <div class="custom-table">
    <div class="row header">
      <div class="col"></div>
      <div class="col grow">{{ "common.name" | translate }}</div>
      <div class="col">{{ "common.type" | translate }}</div>
      <div class="col"></div>
    </div>

    @for (user of visibleUsers; track user) {
    <div class="row" (click)="editUser(user)">
      <div class="col">
        <ion-avatar
          [class.seen-today]="state.isApplicationAdmin && wasSeenToday(user)"
        >
          @if (getProfileImageUrl(user); as imageUrl) {
          <img [src]="imageUrl" [alt]="'user.profileImage' | translate" />
          } @else {
          <ion-icon name="person-circle-outline"></ion-icon>
          }
        </ion-avatar>
      </div>
      <div
        class="col grow"
        [ngClass]="{
          deleted: user.isDeleted || user.isDeactivated
        }"
      >
        {{ user.firstName }} {{ user.lastName }}
      </div>
      <div class="col">{{ getUserTypeLabel(user.type) }}</div>
      <div class="col">
        @if (user.isDeleted) {
        <ion-icon class="red" name="close-circle-outline"></ion-icon>
        } @if (!user.isDeleted && user.isDeactivated) {
        <ion-icon class="orange" name="checkmark-circle-outline"></ion-icon>
        } @if (!user.isDeleted && !user.isDeactivated) {
        <ion-icon class="green" name="checkmark-circle-outline"></ion-icon>
        }
      </div>
    </div>
    }
  </div>
</div>
